import type { PathLookupDecisionEvent } from '@ipfabric/utils';
import type { FC } from 'react';

/**
 * `severityInfo.details` of a decision — TGW attachment / availability-zone
 * diagnostics on a drop, simulation issues on a security check. One line each,
 * as the on-prem grid renders them in its packet-action cell.
 */
export const SeverityDetails: FC<{ event: PathLookupDecisionEvent }> = ({
  event,
}) => (
  <>
    {event.severityInfo?.details?.map((detail) => (
      <div className='text-gray-600' key={detail}>
        {detail}
      </div>
    ))}
  </>
);
